import React from "react";
import { SubPageSectionHeading } from "../components";

export const HowItWorks = () => {
  const benefitCards = [
    {
      title: (
        <>
          Select Your
          <br />
          Cryptocurrency
        </>
      ),
      description: "Choose assets like ETH, BTC, or USDT to bridge.",
    },
    {
      title: (
        <>
          Choose Your
          <br />
          Network
        </>
      ),
      description: "Convert your tokens to $VANRY on the Vanar blockchain.",
    },
    {
      title: (
        <>
          Complete Your Swap
        </>
      ),
      description:
        "Confirm the transaction and enjoy seamless integration into the Vanar ecosystem.",
    },
  ];
  return (
    <section className="relative py-6 lg:py-12">
      <div className="w-full flex items-center justify-center">
        <div className="max-w-[879px] flex flex-col items-center justify-center text-center  gap-2">
          <SubPageSectionHeading className="w-full max-w-[763px] text-[clamp(1.75rem,5vw,2.5rem)] leading-[100%] font-[700] tracking-[-0.05em] uppercase font- gradient-text bg-left-bottom bg-textGd overflow-hidden text-ellipsis text-black">
            How does it work?
          </SubPageSectionHeading>

          <p className="text-gunMetal text-[16px]/[24px]  font-medium font-serif -tracking-[1.1px] ">
            The Router Nitro Bridge is a secure, decentralized platform enabling
            real-time token swaps between chains. Follow three simple steps:
          </p>
        </div>
      </div>
      <div className="grid lg:grid-cols-3 gap-4 mt-10 ">
        {benefitCards.map((item, index) => (
          <div className="col-span-1" key={index}>
            <div className="benefitcard relative  items-start gap-3  lg:min-h-[236px] bg-white hoverCardTop p-6 lg:p-8 group hover:!bg-[#1B2129]  hover:!text-white  h-full flex flex-col  gap-5w-full duration-300  bg-CardBG bg-no-repeat bg-cover bg-right-bottom before:absolute before:bg-contain hover:before:bg-[#1B2129]/80 before:bg-no-repeat before:bg-right-bottom before:bg-yellowDotBg before:bottom-0 before:h-full before:right-0 before:w-full before:z-[-1]">
              {/* <div className="absolute top-3 right-4 size-3 *:size-full text-green group-hover:text-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M12 14L12 2L0 2"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  />
                </svg>
              </div>

              <div className="absolute bottom-3 right-4 size-2 *:size-full text-green group-hover:text-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                >
                  <path
                    d="M8 0L8 8L0 8"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  />
                </svg>
              </div> */}

              <div className="font-serif text-gunMetal group-hover:text-white flex items-center justify-start font-bold text-[20px] uppercase">
                0{index + 1}
              </div>

              <div className="flex flex-col justify-start items-start w-full gap-3 mt-auto pt-4 lg:pt-12">
                <h3
                  style={{
                    fontSize: "clamp(1.25rem, 1.2rem + 0.25vw, 1.5rem)",
                    lineHeight: "clamp(1.25rem, 1.2rem + 0.25vw, 1.5rem)",
                  }}
                  className="font-bold uppercase font-sans tracking-[-1.2px] text-gunMetal group-hover:text-white"
                >
                  {item.title}
                </h3>
                <p className="text-gunMetal text-[12px]/[16px] lg:text-[16px]/[22px] font-medium font-serif group-hover:text-white">
                  {item.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
